
export const SenderTypes = [
    {label: 'Contract Matching', value: 'contract_matching'},
    {label: 'Active Optin', value: 'active_optin'}
]

export const DefaultSenderType = SenderTypes[0];